module.exports = __webpack_public_path__ + "img/User Management.eb0fae79.png";